import { guid } from '@/utils/index'
export function getCommomData() {
  return {
    adminAccount: guid(false).slice(0, 28),
    unifiedCreditCode: guid(false).slice(0, 28),
    businessLicenceFile: '1',
    provinceCode: 110000,
    cityCode: 110100,
    areaCode: 110101,
    vendorAddress: '123456',
    vendorPerson: '123456',
    vendorPhone: '123456',
    memberFlag: 1
  }
}
